mutation CreateContentRequest($text: String!) {
    createContentRequest(text: $text) {
        id
        created_at
        updated_at
        text
    }
}